import { Component, OnInit, Input } from '@angular/core';
import { CompanySubset } from 'app/api/company.api.service';
import { ClientSideRowModelModule, GridOptions, ColDef } from '@ag-grid-enterprise/all-modules';
import { Observable } from 'rxjs';
import { AnalyticsEntry } from 'app/api/analytics.api.service';
import { Store, select } from '@ngrx/store';
import { AppState } from 'app/reducers';
import { AnalyticsSelectors, AnalyticsUISelectors } from 'app/main/analytics/selectors';
import { AnalyticsUIActions } from '../actions';

@Component({
  selector: 'app-analytics-report',
  templateUrl: './analytics-report.component.html',
  styleUrls: ['./analytics-report.component.scss']
})
export class AnalyticsReportComponent implements OnInit {
  @Input() company: CompanySubset;

  public hasChanges = false;
  public modules = [ ClientSideRowModelModule ];

//#region groups
  public groupsOptions: GridOptions = {
    rowSelection: 'single'
  };
  public groupsColumnDefs: ColDef[] = [
    {
      headerName: 'Nom',
      field: 'name',
      // width: 300,
      cellClass: params => params.data && params.data.color,
      rowDrag: true
    },
  ];
  public groupsGridApi;
  public groupsGridColumnApi;
  public groupsData$: Observable<AnalyticsEntry[]>;
//#endregion

//#region ana2
  public ana2Options: GridOptions;
  public ana2ColumnDefs: ColDef[] = [
    {
      headerName: 'Nom',
      field: 'name',
      // width: 300,
      cellClass: params => params.data && params.data.color,
      rowDrag: true
    },
  ];
  public ana2GridApi;
  public ana2GridColumnApi;
  public ana2Data$: Observable<AnalyticsEntry[]>;
//#endregion

  public selectedGroupName$: Observable<string>;

  constructor(protected store: Store<AppState>) {
    this.groupsData$ = store.pipe(select(AnalyticsSelectors.selectGroups));
    this.ana2Data$ = store.pipe(select(AnalyticsSelectors.selectAna2ForReportSelectedGroup));
    this.selectedGroupName$ = store.pipe(select(AnalyticsUISelectors.selectReportSelectedGroupName));
  }

  ngOnInit(): void {
  }

  onGroupsGridReady(params: any): void {
    this.groupsGridApi = params.api;
    this.groupsGridColumnApi = params.columnApi;
  }

  onGroupsSelectionChanged(params: any): void {
    const selectedRows = this.groupsGridApi.getSelectedRows();
    if (selectedRows.length === 1) {
      this.store.dispatch(AnalyticsUIActions.analyticsReportSetSelectedGroup({ entry: selectedRows[0] }));
    }
  }

  onAna2GridReady(params: any): void {
    this.ana2GridApi = params.api;
    this.ana2GridColumnApi = params.columnApi;
  }

  onCancel(): void {}

  onConfirm(): void {}

}
